// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"21ac5281","629":"d386aaa0"}[chunkId] + ".chunk.js";
};